import { IBitlockerKey } from './../../models/IBitLockerKey';
import { IAjaxCreationMethod } from '@microsoft/portal-app/lib/auth';
import { IAction } from '@microsoft/portal-app/lib/redux';
import {
  addAjaxEpic,
  getFailureActionType,
  getSuccessActionType,
} from '@microsoft/portal-app/lib/redux/createAjaxEpic';
import { getBitlockerKeysUrl, getBitlockerRecoveryKeyUrl } from '../../../redux/modules/accountApis';
import { IBitlockerKeyReturnType, IDevice } from '../../models';
import { IDevicesState } from '../../models/IDevicesState';
import { DevicesActions } from '../DevicesActions';
import { devicesRegistry as registry } from '../devicesRegistry';
import { IDevicesAction } from '../IDevicesAction';
import { getTelemetry } from '../../../Telemetry/Telemetry';
import { AjaxError } from 'rxjs';



export const getBitlockerKeyAjax = (ajax: IAjaxCreationMethod, action: IAction<string>) => {
  return ajax.getJSON<IBitlockerKeyReturnType>(getBitlockerKeysUrl(action.payload));
};

const getBitlockerKeySuccess = (
  state: IDevicesState,
  action: IDevicesAction<IBitlockerKeyReturnType>,
): IDevicesState => {
  if (action.payload === undefined) {
    return state;
  }

  const bitlockerKeys = action.payload.value;
  const telemetry = getTelemetry();
  telemetry.reportCustomEvent('devices/get-bitlocker-key-ids/success', { bitlockerKeys });

  // Return empty BitLockeKey in two scenarios:
  // 1. BitLocker is not compatible on the device (only Windows devices are supported)
  // 2. BitLocker is compatible, but there is no BitLocker key configured on the device
  if (bitlockerKeys === null || bitlockerKeys.length === 0) {
    return { ...state, bitlockerIsLoading: false, error: undefined };
  }

  const deviceId = bitlockerKeys[0].deviceId;
  const newDeviceList: Map<string, IDevice> = new Map<string, IDevice>();
  state.devicesById.forEach((value: IDevice, key: string) => {
    if (value.deviceId === deviceId) {
      const newDevice: IDevice = {
        ...value,
        bitLockerKey: bitlockerKeys,
        bitlockerKeyAvailable: true,
      };
      newDeviceList.set(key, newDevice);
    } else {
      newDeviceList.set(key, value);
    }
  });

  return {
    ...state,
    devicesById: newDeviceList,
    bitlockerIsLoading: false,
    error: undefined,
  };
};

registry.add(getSuccessActionType(DevicesActions.getBitlockerKey), getBitlockerKeySuccess);

const getBitlockerKeyAjaxFailure = (state: IDevicesState, action: IDevicesAction<AjaxError>): IDevicesState => {
  const telemetry = getTelemetry();
  telemetry.error('devices/get-bitlocker-key-ids/failed', { error: action.payload });
  return {
    ...state,
    bitlockerIsLoading: false,
    error: action.payload,
  };
};

registry.add(getFailureActionType(DevicesActions.getBitlockerKey), getBitlockerKeyAjaxFailure);

addAjaxEpic(registry, DevicesActions.getBitlockerKey, getBitlockerKeyAjax);

export const getBitlockerRecoveryKeyAjax = (ajax: IAjaxCreationMethod, action: IAction<string>) => {
  return ajax.getJSON<IBitlockerKey>(getBitlockerRecoveryKeyUrl(action.payload));
};

const getBitlockerRecoveryKeySuccess = (state: IDevicesState, action: IDevicesAction<IBitlockerKey>): IDevicesState => {
  if (action.payload === undefined) {
    return state;
  }

  const bitlockerRecoveryKey = action.payload.key;
  const telemetry = getTelemetry();
  telemetry.reportCustomEvent('devices/get-bitlocker-recovery-key/success', { bitlockerRecoveryKey });

  return {
    ...state,
    bitlockerRecoveryKey: {
      bitlockerRecoveryKey: action.payload.key,
      wasError: false,
    },
  };
};

registry.add(getSuccessActionType(DevicesActions.getBitlockerRecoveryKey), getBitlockerRecoveryKeySuccess);

const getBitlockerRecoveryKeyAjaxFailure = (
  state: IDevicesState,
  action: IDevicesAction<IBitlockerKeyReturnType>,
): IDevicesState => {
  const telemetry = getTelemetry();
  telemetry.error('devices/get-bitlocker-recovery-key/failed', { error: action.payload });
  return {
    ...state,
    bitlockerRecoveryKey: {
      bitlockerRecoveryKey: '',
      wasError: true,
    },
  };
};

registry.add(getFailureActionType(DevicesActions.getBitlockerRecoveryKey), getBitlockerRecoveryKeyAjaxFailure);

addAjaxEpic(registry, DevicesActions.getBitlockerRecoveryKey, getBitlockerRecoveryKeyAjax);
